import React from 'react';
import { Check, CheckCircle2 } from 'lucide-react';
export function BeneficiosIdeal() {
  return <section id="beneficios" className="py-5 sm:py-14 bg-[#0a1628] border-t border-gray-800" data-id="element-30">
      <div className="max-w-5xl mx-auto px-3 sm:px-6" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-8" data-id="element-32">
          {/* Left Column: Ideal Para */}
          <div className="bg-[#1e293b]/50 p-3 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-33">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-2 sm:mb-5 border-b border-gray-700 pb-2 sm:pb-3" data-id="element-34">
              Este kit es ideal para:
            </h3>
            <ul className="space-y-1.5 sm:space-y-3" data-id="element-35">
              {['Docentes de Lengua y Literatura de nivel secundario', 'Profesores que trabajan en varias instituciones', 'Docentes que buscan estructura y organización anual', 'Educadores que desean material listo para aplicar', 'Estudiantes de formación docente'].map((item, index) => <li key={index} className="flex items-start" data-id="element-36">
                  <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-37">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-38" />
                  </div>
                  <span className="text-xs sm:text-base text-gray-200" data-id="element-39">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right Column: Beneficios */}
          <div className="bg-[#1e293b]/50 p-3 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-40">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-2 sm:mb-5 border-b border-gray-700 pb-2 sm:pb-3" data-id="element-41">
              Beneficios del Kit
            </h3>
            <ul className="space-y-1.5 sm:space-y-3" data-id="element-42">
              {['Material organizado por ejes centrales de Lengua y Literatura', 'Recursos listos para implementar en el aula', 'Contenido adaptable a distintos diseños curriculares de Latinoamérica', 'Enfoque pedagógico claro y estructurado', 'Ahorro real de tiempo con el sistema completo organizado'].map((item, index) => <li key={index} className="flex items-start" data-id="element-43">
                  <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-44">
                    <CheckCircle2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-45" />
                  </div>
                  <span className="text-xs sm:text-base text-gray-200 font-medium" data-id="element-46">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}